<template>
  <div class="p-card vertical-card">
    <div class="img-container s-ratio-16-9 pointer">
      <img
        @click="onClick"
        src="@/assets/default-course.png"
        class="img-course-card s-transition"
      />
    </div>
    <div class="p-col-12 p-px-4 p-pt-3 vertical-card-content">
      <slot name="default"></slot>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>

<style>
.vertical-card,
.vertical-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.vertical-card {
  border-radius: 1rem;
}

.vertical-card .link {
  cursor: pointer;
  color: #e65100;
  text-decoration: underline;
}
.vertical-card .name {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.4rem;
  text-align: left;
}
.vertical-card .text {
  color: #000000a6;
}

.vertical-card > .link:hover {
  text-decoration-color: var(--primary-color);
}
</style>



// WEBPACK FOOTER //
// src/components/base/VerticalCard.vue